import React from 'react';
import { Box, Flex, Heading, Table, Button, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';

import { TableLoaderOverlay } from 'shared/components';

import { useManageCvs } from './manage-cvs.provider';
import { CvActionsMenu } from './cv-actions-menu';
import { CvStatusBadge } from './cv-status-badge';
import './manage-cvs.scss';

const ManageCvsView = () => {
   const manageCvs = useManageCvs();

   React.useEffect(() => {
      manageCvs.loadCvs();
   }, []);
   
   return (
      <Box className="candidate-cvs" mb={{ initial: '0', md: '4' }}>
         <header className="header">
            <Flex align="center" gap="1">
               <img alt="alert" src="/Images/jobseekerSide/cv-list-color.png" />
               <Heading as="h3" size="7" className="heading">
                  Мої резюме
               </Heading>
            </Flex>
         </header>
         <Box pb="4">
            <Table.Root className="candidate-cvs-table" layout="auto" variant="ghost" mb="-3">
               <Table.Header className="table-header" id="alertsTable">
                  <Table.Row className="table-header-row">
                     <Table.ColumnHeaderCell className="table-header-cell" px="5" py="4">
                        Назва резюме
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell className="table-header-cell" px="4" py="4">
                        Оновлено
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        justify="center"
                        px="4"
                        py="4"
                     >
                        Перегляди
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        justify="center"
                        width="100px"
                        px="4"
                        py="4"
                     >
                        Статус
                     </Table.ColumnHeaderCell>

                     <Table.ColumnHeaderCell
                        className="table-header-cell"
                        width="150px"
                        justify="center"
                        px="4"
                        py="4"
                     >
                        Дії
                     </Table.ColumnHeaderCell>
                  </Table.Row>
               </Table.Header>

               <Table.Body>
                  <TableLoaderOverlay
                     show={manageCvs.loadCvsState.status === 'pending'}
                     colSpan={4}
                  />

                  {manageCvs.resumes.map((cv, idx) => {
                     return (
                        <Table.Row className="table-row" key={cv.id}>
                           <Table.Cell
                              className="table-cell"
                              justify="start"
                              align="center"
                              px="4"
                              py="5"
                           >
                              <Flex direction="column" gap="1">
                                 <a href={`/candidate/my-cv-list/${cv.id}`}>{cv.name}</a>
                                 <Text size="2" weight="medium">{cv.visibilityName}</Text>
                              </Flex>
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell"
                              width="205px"
                              align="char"
                              justify="start"
                              px="4"
                              py="5"
                           >
                              {cv.updated}
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell"
                              align="justify"
                              justify="center"
                              px="4"
                              py="5"
                           >
                              {cv.views}
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell"
                              align="justify"
                              justify="center"
                              px="4"
                              py="5"
                           >
                              <CvStatusBadge status={cv.status} />
                           </Table.Cell>

                           <Table.Cell
                              className="table-cell action-cell"
                              justify="center"
                              px="4"
                              py="5"
                              align="justify"
                           >
                              <CvActionsMenu candidateCv={cv} />
                           </Table.Cell>
                        </Table.Row>
                     );
                  })}
               </Table.Body>
            </Table.Root>
         </Box>

         <Flex
            className="pagination"
            align="center"
            justify="center"
            pt="4"
            direction="column"
            gap="2"
         >
            <Flex>
               {manageCvs.rawCvs.length > 0 && (
                  <Text color="gray">
                     Кількість записів {manageCvs.recordsCount} of {manageCvs.rawCvs.length}
                  </Text>
               )}
            </Flex>
            <Box>
               <Flex align="center" gap="4">
                  <Button
                     radius="small"
                     size="4"
                     disabled={!manageCvs.canPrev}
                     onClick={() => {
                        manageCvs.onPrev();
                     }}
                  >
                     Попередня
                  </Button>

                  <Button
                     radius="small"
                     size="4"
                     disabled={!manageCvs.canNext}
                     onClick={() => {
                        manageCvs.onNext();
                     }}
                  >
                     Наступна
                  </Button>
               </Flex>
            </Box>
         </Flex>
      </Box>
   );
};

export const ManageCvs = observer(ManageCvsView);
